import { useEffect, useState } from "react";
import { getDashboardStats } from "../lib/api.js";

export default function AdminDashboard() {
const [stats, setStats] = useState({
enquiries: 0,
downloads: 0,
chatbot: 0
});

useEffect(() => {
async function load() {
try {
const data = await getDashboardStats();
setStats(data);
} catch (error) {
console.error(error);
}
}

load();

}, []);

return ( <div className="mx-auto max-w-7xl px-6 py-10"> <h1 className="mb-8 text-4xl font-bold">
SURBANCO Admin Dashboard </h1>


  <div className="grid gap-6 md:grid-cols-3">
    <div className="rounded-2xl bg-white p-6 shadow">
      <h3 className="text-lg font-semibold">
        Total Enquiries
      </h3>

      <p className="mt-3 text-4xl font-bold">
        {stats.enquiries}
      </p>
    </div>

    <div className="rounded-2xl bg-white p-6 shadow">
      <h3 className="text-lg font-semibold">
        Total Downloads
      </h3>

      <p className="mt-3 text-4xl font-bold">
        {stats.downloads}
      </p>
    </div>

    <div className="rounded-2xl bg-white p-6 shadow">
      <h3 className="text-lg font-semibold">
        Chatbot Questions
      </h3>

      <p className="mt-3 text-4xl font-bold">
        {stats.chatbot}
      </p>
    </div>
  </div>
</div>

);
}
